import {
  AlignItems,
  Body2,
  Box,
  Color,
  Display,
  Icon,
  IconVariant,
  JustifyContent,
  Space,
  Strong,
  TextAlign,
  withCitrusTheme,
} from '@gousto-internal/citrus-react';
import { ButtonLink } from '../ButtonLink/ButtonLink';

type Props = {
  onBuildYourBoxClick: () => void;
};

const BODY_2_SIZE = 4;

const CtaWrapper = withCitrusTheme(Box, () => ({
  '& a': {
    borderRadius: '8px',
  },
}));

export function BuildYourBoxFooter({ onBuildYourBoxClick }: Props): JSX.Element {
  return (
    <Box>
      <Body2 size={BODY_2_SIZE} color={Color.ColdGrey_800} textAlign={TextAlign.Center}>
        <Strong color={Color.Success_900}>Free delivery</Strong>
        <Strong> on your first box (usually €4.99)</Strong>
      </Body2>
      <Space size={4} />
      <CtaWrapper>
        <ButtonLink href="/signup" onClick={onBuildYourBoxClick} width="100%">
          Build your box
        </ButtonLink>
      </CtaWrapper>
      <Space size={3} />
      <Box
        display={Display.Flex}
        justifyContent={JustifyContent.Center}
        alignItems={AlignItems.Center}
        gap={1}
      >
        <Icon name="play_pause" variant={IconVariant.Inherit} aria-hidden="true" />
        <Body2 size={BODY_2_SIZE} color={Color.ColdGrey_800}>
          <Strong>No lock in:</Strong> skip or cancel for free any time
        </Body2>
      </Box>
    </Box>
  );
}
